<template>
  <div v-show="false" />
</template>
<script>
export default {
    name: 'SlotScopeWatcher',
    props: {
        value: {
            type: [Boolean, String, Array, File, Object, Number],
            default: undefined,
        },
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.$emit('change', this.value);
            },
        },
    },
};
</script>
